export const tabTaxCouvert = {
	emptyTaxCouvertMessage: "No existen datos fiscales de cover para mostrar",
	infosTaxCouvert: {
		cest: "CEST",
		cfop: "CFOP",
		code: "SKU",
		group: "Grupo",
		ncm: "NCM",
		profile: "Perfil",
	},
	searchPlaceholder: "Buscar datos fiscales de cover",
};
